<template>
  <div class="home">
    <UserTopbar />

    <div class="container">
      <!-- CTA TORNEO -->
      <RouterLink to="/tournament">
        <div class="tournament-cta">
          <h3>Gioca un torneo!</h3>
          <p>
            Premi qui e partecipa
          </p>
        </div>
      </RouterLink>

      <!-- CTA COMPONENTI -->
      <div class="cta-squaregrid">
        <RouterLink to="/randomizer">
          <div class="cta-box">
            <div class="big-icon">
              <img src="@/assets/imgs/illustrations/random-bey-illustration.webp" alt="Beyblade Randomizer" />
            </div>
            <h3>
              Bey Casuali
            </h3>
          </div>
        </RouterLink>
        <RouterLink to="/tournament-ban">
          <div class="cta-box">
            <div class="big-icon">
              <img src="@/assets/imgs/illustrations/ban-bey-illustration.webp" alt="Torneo Ban" />
            </div>
            <h3>
              Torneo Ban
            </h3>
          </div>
        </RouterLink>
        <RouterLink to="/register-your-beys">
          <div class="cta-box">
            <div class="big-icon">
              <img src="@/assets/imgs/illustrations/addcomponent-bey-illustration.webp" alt="Registra componenti" />
            </div>
            <h3>
              Parti Bey
            </h3>
          </div>
        </RouterLink>
        <RouterLink to="/rules">
          <div class="cta-box">
            <div class="big-icon">
              <img src="@/assets/imgs/illustrations/regolamento-bey-illustration.webp" alt="Registra componenti" />
            </div>
            <h3>
              Regolamento
            </h3>
          </div>
        </RouterLink>
      </div>

    </div>
  </div>
</template>

<script>
import UserTopbar from '@/components/user-topbar/UserTopbar.vue';

export default {
  name: 'HomeView',
  components: {
    UserTopbar,
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/cta-boxes.scss';
</style>
